import { Box, Center } from '@chakra-ui/react';
import React, { Component } from 'react';
import Constants from '../../Constants';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { validatePassword, getTenantFromDomain } from '../../utils';
import { Alert } from '../ui/alert';

const isCfcTenant = getTenantFromDomain().includes('cfc');

function getParameterByName(name, url = window.location.href) {
  const nameWithRegex = name.replace(/[[\]\\]/g, '\\$&');
  const regex = new RegExp(`[?&]${nameWithRegex}(=([^&#]*)|&|#|$)`);

  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

class ResetPassword extends Component {
  static propTypes = {
    theme: PropTypes.node.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: false,
      newPassword: '',
      confirmPassword: '',
      email: '',
    };
  }

  componentDidMount() {
    const email = getParameterByName('email');
    if (email) {
      this.setState({ email });
    }
  }

  handlePasswordChange(e) {
    e.preventDefault();
    const { newPassword, confirmPassword, email } = this.state;
    const validationError = validatePassword(newPassword, email);
    if (validationError) {
      this.setState({ error: validationError });
      return;
    }
    if (newPassword !== confirmPassword) {
      this.setState({ error: 'Passwords do not match.' });
      return;
    }

    this.setState({ error: false });
    const token = getParameterByName('token');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });

    fetch(`${Constants.URL}reset-password`, {
      method: 'POST',
      headers: header,
      body: JSON.stringify({
        password: newPassword,
      }),
    })
      .then(response => response.json())
      .then(json => {
        if (json.title) {
          this.setState({ error: json.title });
        } else {
          window.location = '/logout';
        }
      })
      .catch(error => alert(error));
  }

  render() {
    const { theme } = this.props;
    const { newPassword, error } = this.state;

    return (
      <div className="login-container login-page">
        <div className="login">
          <div className="title">
            <Center>{theme?.data?.home?.logo && <img className="logo" src={theme?.data?.home?.logo} alt="" />}</Center>
            <h3 id="form-title" className="form-title font-green" style={{ fontWeight: isCfcTenant ? 'bold' : '400', color: isCfcTenant ? '#0F1B48' : '' }}>
              {theme?.data?.home?.welcomeMsg}
            </h3>
          </div>
          <div className="content">
            <form className="login-form" onSubmit={this.handlePasswordChange.bind(this)}>
              <p className="autologin-text-0">Enter a new password below.</p>
              <div
                style={{
                  color: '#fff',
                  backgroundColor: isCfcTenant ? '#0F1B48' : '#53b0f8',
                  borderColor: '#45aaf8',
                  padding: '10px 20px',
                  borderRadius: '4px',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  marginBottom: '14px',
                }}
              >
                <span>
                  Password must be between 12 and 70 characters long. It should not contain your email address. It must
                  include at least one uppercase letter (A-Z), one lowercase letter (a-z), one number (0-9), and one
                  special character from the allowed set: ! @ # $ % & * ~ _ + Single (') and double (") quotes are not
                  permitted.
                </span>
              </div>
              <input
                id="password-reset-input"
                className="form-control form-control-solid placeholder-no-fix"
                type="password"
                onChange={e => this.setState({ newPassword: e.target.value })}
                value={newPassword}
                placeholder="New Password"
              />
              <input
                id="confirm-password-input"
                className="form-control form-control-solid placeholder-no-fix"
                type="password"
                onChange={e => this.setState({ confirmPassword: e.target.value })}
                value={this.state.confirmPassword}
                placeholder="Confirm Password"
                style={{ marginTop: '10px' }}
              />
              {error && (
                <Box mt={4}>
                  <Alert status="error" title={error} />
                </Box>
              )}
              <div className="form-actions">
                <button type="submit" value="continue" style={{ backgroundColor: isCfcTenant ? '#0F1B48' : '' }} >
                  Continue
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps)(ResetPassword);
